/**
 * Toast Notifications
 * Wrapper around Sonner toast library with PAO styling
 */

import { toast as sonnerToast } from 'sonner'

/**
 * Success toast with PAO green
 */
export function success(message: string, description?: string) {
  sonnerToast.success(message, {
    description,
    duration: 4000,
  })
}

/**
 * Error toast with PAO red
 */
export function error(message: string, description?: string) {
  sonnerToast.error(message, {
    description,
    duration: 5000,
  })
}

/**
 * Info toast with PAO navy
 */
export function info(message: string, description?: string) {
  sonnerToast.info(message, {
    description,
    duration: 4000,
  })
}

/**
 * Warning toast with PAO gold
 */
export function warning(message: string, description?: string) {
  sonnerToast.warning(message, {
    description,
    duration: 4000,
  })
}

/**
 * Loading toast
 */
export function loading(message: string) {
  return sonnerToast.loading(message)
}

/**
 * Promise toast - shows loading, then success/error
 */
export function promise<T>(
  promise: Promise<T>,
  messages: {
    loading: string
    success: string | ((data: T) => string)
    error: string | ((error: any) => string)
  }
) {
  return sonnerToast.promise(promise, messages)
}

/**
 * Dismiss toast by ID
 */
export function dismiss(toastId?: string | number) {
  sonnerToast.dismiss(toastId)
}

// Export all methods
export const toast = {
  success,
  error,
  info,
  warning,
  loading,
  promise,
  dismiss,
}

export default toast
